import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  styled,
} from "@mui/material";

import { getData } from "../services/Request";
import { useLoader } from "../context/LoaderContext";

const rowsPerPageOptions = [10, 20, 30];
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: 20,
  backgroundColor: "#61ED66",
  color: theme.palette.common.white,
}));

const PaymentReceived = () => {
  const { showLoader, hideLoader } = useLoader();
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(rowsPerPageOptions[0]);

  useEffect(() => {
    getAllPayments();
  }, []);

  const getAllPayments = () => {
    showLoader();
    getData("mpesa/allPayments")
      .then((response) => {
        setPayments(response);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        hideLoader();
      });
  };
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const slicedData = payments.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  return (
    <>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow
              sx={{
                backgroundColor: "#52057B !important",
              }}
            >
              <TableCell sx={{ color: "#ffffff" }}>#</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>Name</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>email</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>Ref</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>GroupPlanId</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>Currency</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>Amount</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>Status</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>AppFee</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>MerchantFee</TableCell>
              <TableCell sx={{ color: "#ffffff" }}>CustomerId</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {slicedData.map((row, index) => (
              <TableRow key={row.id} hover>
                <TableCell>{index + 1}</TableCell>

                <TableCell>{row.customerFullName}</TableCell>
                <TableCell>{row.customerEmail}</TableCell>
                <TableCell>{row.txRef}</TableCell>
                <TableCell>{row.paymentPlan}</TableCell>
                <TableCell>{row.currency}</TableCell>
                <TableCell>{row.amount}</TableCell>
                <TableCell>{row.status}</TableCell>
                <TableCell>{row.appfee}</TableCell>
                <TableCell>{row.merchantbearsfee}</TableCell>
                <TableCell>{row.customerId}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={rowsPerPageOptions}
        component="div"
        count={payments.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default PaymentReceived;
